import moment from 'moment';

import { BasicTableOptions } from '../BasicTableOptions/BasicTableOptions';

export interface ClientMessagesTableOptions
    extends Omit<BasicTableOptions, 'SelectedFilter'> {
    SelectedDateField: 'StartAt' | 'EndAt' | '';
    SelectedFilter: 'pending' | 'none';
}

export const clientMessageInitialDateRange = {
    StartAt: {
        start: moment()
            .subtract(1, 'week')
            .startOf('day'),
        end: moment()
            .add(1, 'year')
            .endOf('day')
    }
};

export const clientMessagesTableOptionsInitialState: ClientMessagesTableOptions = {
    PageNo: 1,
    RecordPerPage: 15,
    Sort: 'StartAt|ASC',
    DefaultSort: 'StartAt|ASC',
    SelectedDateFilter: 'clientMessageInitialState',
    SelectedDateField: 'StartAt',
    DateCondition: `StartAt|GT|${
        clientMessageInitialDateRange
            .StartAt
            .start
            .format('x')
    }:StartAt|LT|${
        clientMessageInitialDateRange
            .StartAt
            .end
            .format('x')
    }`,
    SelectedFilter: 'none',
    TableFilters: [],
    FilterCondition: '',
    DefaultState: true
};